import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { createContext, useContext } from "react";
//Limitless imports
// Set the default state values for each context
var SettingsDrawerContext = createContext({});

var useSettingsDrawerHook = function useSettingsDrawerHook() {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isDrawerOpen = _React$useState2[0],
      setIsDrawerOpen = _React$useState2[1];

  var toggleSettingsDrawer = function toggleSettingsDrawer() {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return {
    isDrawerOpen: isDrawerOpen,
    toggleSettingsDrawer: toggleSettingsDrawer
  };
};

export var SettingsDrawerContextProvider = function SettingsDrawerContextProvider(_ref) {
  var children = _ref.children;
  var settingsDrawer = useSettingsDrawerHook();
  return /*#__PURE__*/React.createElement(SettingsDrawerContext.Provider, {
    value: settingsDrawer
  }, children);
};
export var useSettingsDrawer = function useSettingsDrawer() {
  return useContext(SettingsDrawerContext);
};